import Vue from 'vue';
import VueRouter from 'vue-router';
import store from '../store';
import Home from '../views/Home.vue';
import Register from '../components/Register.vue';
import VerifyOtp from '../components/VerifyOtp.vue';

import SudLifeLandingPage from '../components/sudlife-client/LandingPage.vue';
import SudLifeUserVerifyOtp from '../components/Register/SuidLifeEmailOtpVarification.vue';


import Dashboard from '../components/Dashboard.vue';
import Login from '../components/Login.vue';
import Forgotpassword from '../components/Forgotpassword.vue';
import ConfirmNewPassword from '../components/ConfirmNewPassword.vue';
import Changepassword from '../components/Changepassword.vue';
import SetupNewPassword from '../components/SetupNewPassword.vue';

import EditProfile from '../components/EditProfile.vue';
//import SendMobileOtp from '../components/user/SendMobileOtp.vue';
import VerifyMobileOtp from '../components/VerifyMobileOtp.vue';
import Investometer from '../components/Investometer/Investometer.vue';
import RewardsPoint from '../components/Dashboards/RewardsPoint.vue';
import ContactUsForm from '../components/common/ContactUsForm.vue';
import AddNewMember from '../components/Member/AddNewMember.vue';
import EditNewMember from '../components/Member/EditNewMember.vue';
// import razorpay from '../components/razorpay/razorpay.vue';
import congratulations from '../components/congratulations/congratulations.vue';
import SubscriptionCongratulations from '../components/congratulations/SubscriptionCongratulations.vue';
import pricingPlan from '../components/pricingPlan/pricingPlan.vue';
import PaymentDetail from '../components/pricingPlan/PaymentDetail.vue';
import ChooseOption from '../components/pricingPlan/ChooseOption.vue';
import Myplan from '../components/Myplan/MyPlanList.vue';
import CorsComponent from '../components/cors/CorsComponent.vue';
import Investment from '../components/Investment/Investment.vue';
import SubCategory from '../components/Investment/SubCategory.vue';
import SavingComponent from '../components/Investment/SavingComponent.vue';
import DepositeDashboard from '../components/Deposite/DepositeDashboard.vue';
import SukanyaSamriddhiYogna from '../components/Deposite/SukanyaSamriddhiYogna.vue';
import FixedDeposit from '../components/Deposite/FixedDeposit.vue';
import RecurringDeposits from '../components/Deposite/RecurringDeposits.vue';
import EditSavingAccounts from '../components/Deposite/EditSavingAccounts.vue';
import EditFixedDeposit from '../components/Deposite/EditFixedDeposit.vue';
import EditSukanyaSamriddhiYogna from '../components/Deposite/EditSukanyaSamriddhiYogna.vue';
import EditRecurringDeposite from '../components/Deposite/EditRecurringDeposite.vue';
import MutualFundsDasboard from '../components/MutualFund/MutualFundsDashboard.vue';
import AddLumpsumInvestment from '../components/MutualFund/AddLumpsumInvestment.vue';
import EditLumpsumInvestment from '../components/MutualFund/EditLumpsumInvestment.vue';
import AddSystematicInvestmentPlan from '../components/MutualFund/AddSystematicInvestmentPlan.vue';
import EditSystematicInvestmentPlan from '../components/MutualFund/EditSystematicInvestmentPlan.vue';
import EquitiesDashboard from '../components/EquitiesBond/EquitiesDashboard.vue';
import AddEquities from '../components/EquitiesBond/AddEquities.vue';
import AddExchangeTradedFund from '../components/EquitiesBond/AddExchangeTradedFund.vue';
import AddBonds from '../components/EquitiesBond/AddBonds.vue';
import EditEquities from '../components/EquitiesBond/EditEquities.vue';
import EditExchangeTradedFund from '../components/EquitiesBond/EditExchangeTradedFund.vue';
import EditBonds from '../components/EquitiesBond/EditBonds.vue';
import LiabilitiesDashboard from '../components/Liabilities/LiabilitiesDashboard.vue';
import LiabilitiesSubCategory from '../components/Liabilities/LiabilitiesSubCategory.vue';
import homeLoanAdd from '../components/Liabilities/homeloan/homeLoanAdd.vue';
import homeLoanEdit from '../components/Liabilities/homeloan/homeLoanEdit.vue';
import personalLoanAdd from '../components/Liabilities/personalLoan/personalLoanAdd.vue';
import personalLoanEdit from '../components/Liabilities/personalLoan/personalLoanEdit.vue';
import consumerLoanAdd from '../components/Liabilities/consumerLoan/ConsumerLoanAdd.vue';
import ConsumerLoanEdit from '../components/Liabilities/consumerLoan/ConsumerLoanEdit.vue';
import StudentLoanAdd from '../components/Liabilities/studentLoan/StudentLoanAdd.vue';
import StudentLoanEdit from '../components/Liabilities/studentLoan/StudentLoanEdit.vue';
import AddCarLoan from '../components/Liabilities/carLoan/AddCarLoan.vue';
import EditCarLoan from '../components/Liabilities/carLoan/EditCarLoan.vue';

import AddTwoWheelerLoan from '../components/Liabilities/twoWheelerLoan/AddTwoWheelerLoan.vue';
import EditTwoWheelerLoan from '../components/Liabilities/twoWheelerLoan/EditTwoWheelerLoan.vue';

import AddOverDraft from '../components/Liabilities/overdraft/AddOverDraft.vue';
import EditOverDraft from '../components/Liabilities/overdraft/EditOverDraft.vue';

import AddPolicyLoan from '../components/Liabilities/policyLoan/AddPolicyLoan.vue';
import EditPolicyLoan from '../components/Liabilities/policyLoan/EditPolicyLoan.vue';

import AddLoanAgainstProperty from '../components/Liabilities/LoanAgainstProperty/AddLoanAgainstProperty.vue';
import EditLoanAgainstProperty from '../components/Liabilities/LoanAgainstProperty/EditLoanAgainstProperty.vue';

import AddCreditCardLoan from '../components/Liabilities/creditCardLoan/AddCreditCardLoan.vue';
import EditCreditCard from '../components/Liabilities/creditCardLoan/EditCreditCardLoan.vue';

import AddBarsAndCoins from '../components/Investment/BarsAndCoins/AddBarsAndCoins';

import EditBarsAndCoins from '../components/Investment/BarsAndCoins/EditBarsAndCoins';

import AddJewellery from '../components/Investment/jewellery/AddJewellery.vue';
import EditJewellery from '../components/Investment/jewellery/EditJewellery.vue';

import BullionsDashboards from '../components/Investment/BullionDashboard.vue';

import AddDigitalGold from '../components/Investment/DigitalGold/AddDigitalGold.vue';
import EditDigitalGold from '../components/Investment/DigitalGold/EditDigitalGold.vue';

import AddGoldBonds from '../components/Investment/GoldBonds/AddGoldBonds.vue';
import EditGoldBonds from '../components/Investment/GoldBonds/EditGoldBonds.vue';

import AccountsDashboard from '../components/Accounts/AccountsDashboard.vue';
import AccountsSubCategory from '../components/Accounts/AccountsSubCategory.vue';

import AddDemat from '../components/Accounts/dematAccount/AddDemat.vue';
import EditDemat from '../components/Accounts/dematAccount/EditDemat.vue';

import AddTrading from '../components/Accounts/tradingAccount/AddTrading.vue';
import EditTrading from '../components/Accounts/tradingAccount/EditTrading.vue';

import AddEInsurance from '../components/Accounts/eInsuranceAccount/AddEInsurance.vue';
import EditEInsurance from '../components/Accounts/eInsuranceAccount/EditEInsurance.vue';

//Commodities Dashboards
import AddCommodities from '../components/Investment/commodities/AddCommodities.vue';
import EditCommodities from '../components/Investment/commodities/EditCommodities.vue';
import CommoditiesDashboard from '../components/Investment/commodities/CommoditiesDashboard.vue';

//Insurance
import InsuranceDashboard from '../components/Investment/Insurances/InsuranceDashboard.vue';
import AddLife from '../components/Investment/Insurances/LifeInsurance/AddLife.vue';
import EditLife from '../components/Investment/Insurances/LifeInsurance/EditLife.vue';
import AddHealth from '../components/Investment/Insurances/HealthInsurance/AddHealth.vue';
import EditHealth from '../components/Investment/Insurances/HealthInsurance/EditHealth';
import AddVehicle from '../components/Investment/Insurances/VehicleInsurance/AddVehicle';
import EditVehicle from '../components/Investment/Insurances/VehicleInsurance/EditVehicle.vue';
import AddGroup from '../components/Investment/Insurances/GroupInsurance/AddGroup.vue';
import EditGroup from '../components/Investment/Insurances/GroupInsurance/EditGroup.vue';
import AddProperty from '../components/Investment/Insurances/PropertyInsurance/AddProperty.vue';
import EditProperty from '../components/Investment/Insurances/PropertyInsurance/EditProperty.vue';
import AddTravel from '../components/Investment/Insurances/TravelInsurance/AddTravel.vue';
import EditTravel from '../components/Investment/Insurances/TravelInsurance/EditTravel.vue';
import AddAccidental from '../components/Investment/Insurances/AccidentalInsurance/AddAccidental.vue';
import EditAccidental from '../components/Investment/Insurances/AccidentalInsurance/EditAccidental.vue';

//Retirement
import RetirementDashboard from '../components/Investment/Retirement/RetirementDashboard.vue';
import AddAnnuityScheme from '../components/Investment/Retirement/AnnuityScheme/AddAnnuityScheme.vue';
import EditAnnuityScheme from '../components/Investment/Retirement/AnnuityScheme/EditAnnuityScheme.vue';

import AddEmployeeProvidentFund from '../components/Investment/Retirement/EmployeeProvidedFund/AddEmployeeProvidentFund.vue';
import EditEmployeeProvidentFund from '../components/Investment/Retirement/EmployeeProvidedFund/EditEmployeeProvidentFund.vue';

import AddMonthlyIncomeScheme from '../components/Investment/Retirement/MonthlyIncomeScheme/AddMonthlyIncomeScheme.vue';
import EditMonthlyIncomeScheme from '../components/Investment/Retirement/MonthlyIncomeScheme/EditMonthlyIncomeScheme.vue';

import AddNationalPensionScheme from '../components/Investment/Retirement/NationalPensionScheme/AddNationalPensionScheme.vue';
import EditNationalPensionScheme from '../components/Investment/Retirement/NationalPensionScheme/EditNationalPensionScheme.vue';

import AddProvidedFund from '../components/Investment/Retirement/ProvidedFund/AddProvidedFund.vue';
import EditProvidedFund from '../components/Investment/Retirement/ProvidedFund/EditProvidedFund.vue';
//Real State
import RealStateDashboard from '../components/Investment/RealState/RealStateDashboard.vue';
//Residential Real State
import AddResidentialRealState from '../components/Investment/RealState/ResidentialRealState/AddResidentialRealState.vue';
import EditResidentialRealState from '../components/Investment/RealState/ResidentialRealState/EditResidentialRealState.vue';

//Commercial Real State
import AddCommercialRealState from '../components/Investment/RealState/CommercialRealState/AddCommercialRealState.vue';
import EditCommercialRealState from '../components/Investment/RealState/CommercialRealState/EditCommercialRealState.vue';
//Industrial Real State
import AddIndustrialRealState from '../components/Investment/RealState/IndustrialRealState/AddIndustrialRealState.vue';
import EditIndustrialRealState from '../components/Investment/RealState/IndustrialRealState/EditIndustrialRealState.vue';
//Land State
import AddLandState from '../components/Investment/RealState/LandState/AddLandState.vue';
import EditLandState from '../components/Investment/RealState/LandState/EditLandState.vue';

//Real State Investment Trust
import AddRealStateInvestmentTrust from '../components/Investment/RealState/RealStateInvestmentTrust/AddRealStateInvestmentTrust.vue';
import EditRealStateInvestmentTrust from '../components/Investment/RealState/RealStateInvestmentTrust/EditRealStateInvestmentTrust.vue';

//Infrastructure Investment Trust
import AddInfraInvestmentTrust from '../components/Investment/RealState/InfrasturctureInvestmentTrust/AddInfraInvestmentTrust.vue';
import EditInfraInvestmentTrust from '../components/Investment/RealState/InfrasturctureInvestmentTrust/EditInfraInvestmentTrust.vue';

//Private Investment
import PrivateInvestmentDashboard from '../components/Investment/PrivateInvestment/PrivateInvestmentDashboard.vue';

//Employee Stock Opt. Services
import AddEmployeeStock from '../components/Investment/PrivateInvestment/EmployeeStock/AddEmployeeStock.vue';
import EditEmployeeStock from '../components/Investment/PrivateInvestment/EmployeeStock/EditEmployeeStock.vue';

//Portfolio Mgmt
import AddPortfolioMgmt from '../components/Investment/PrivateInvestment/PortfolioMgmt/AddPortfolioMgmt.vue';
import EditPortfolioMgmt from '../components/Investment/PrivateInvestment/PortfolioMgmt/EditPortfolioMgmt.vue';

//AlternateInvestment
import AddAlternateInvestment from '../components/Investment/PrivateInvestment/AlternateInvestment/AddAlternateInvestment.vue';
import EditAlternateInvestment from '../components/Investment/PrivateInvestment/AlternateInvestment/EditAlternateInvestment.vue';

//Notification
import Notification from '../components/Notification/notification.vue';

import KeepSafeCategory from '../components/KeepSafe/category.vue';
import KeepSafeSubCategory from '../components/KeepSafe/sub_category.vue';
import DepositKeepSafe from '../components/KeepSafe/deposit.vue';
import MutualFundKeepSafe from '../components/KeepSafe/mutual_fund.vue';
import RealEstateKeepSafe from '../components/KeepSafe/real_estate.vue';
import EquitiesBondsKeepSafe from '../components/KeepSafe/equity_bond.vue';
import InsuranceKeepSafe from '../components/KeepSafe/insurance.vue';
import RetirementKeepSafe from '../components/KeepSafe/retirement.vue';
import CommodityKeepSafe from '../components/KeepSafe/commodity.vue';
import PrivateInvestmentKeepSafe from '../components/KeepSafe/private_investment.vue';
import BullionsKeepSafe from '../components/KeepSafe/bullions.vue';
import TaxFillingKeepSafe from '../components/KeepSafe/tax_filling.vue';
import MyWillKeepSafe from '../components/KeepSafe/my-will.vue';
import ChoosePaymentOptions from '../components/payment/payment_options.vue';
import PermanentlyCloseAccount from '../components/account-management/PermanentlyCloseAccount.vue';
import DeactivateAccount from '../components/account-management/DeactivateAccount.vue';
import OtpVarification from '../components/account-management/OtpVarification.vue';
import moment from 'moment';
import LoginLayout from '../components/Admin/LoginLayout.vue';
import AdminDashboard from '../components/Admin/AdminDashboard.vue';
import AdminCampaign from '../components/Admin/campaign/AdminCampaign.vue';
import AddCampaign from '../components/Admin/campaign/AddCampaign.vue';
import CampaignTopic from '../components/Admin/campaignstopic/CampaignTopic.vue';
import CampaignTopicForm from '../components/Admin/campaignstopic/CampaignTopicForm.vue';
import EditCampaignTopic from '../components/Admin/campaignstopic/EditCampaignTopic.vue';
import EditCampaign from '../components/Admin/campaign/EditCampaign.vue';
import Settings from '../components/Admin/settings/list';
import Edit_list from '../components/Admin/settings/Edit_list';
import Users from '../components/Admin/users/list';
import SubscriptionPlan from '../components/Admin/subscription/list';
import DiscountRate from '../components/Admin/discount/DiscountRate';
import EditList from '../components/Admin/subscription/EditList';
import AddRate from '../components/Admin/discount/Add_Rate';
import AddWillCoupon from '../components/Admin/will-coupon/AddWillCoupon.vue';
import EditWillCoupon from '../components/Admin/will-coupon/EditWillCoupon.vue';
import ListWillCoupon from '../components/Admin/will-coupon/ListWillCoupon.vue';
import EditRate from '../components/Admin/discount/Edit_Rate';
import MostVisitedPage from '../components/Admin/mostvisited/MostVisitedPage';
import AddFinTalk from '../components/Admin/fintalk/AddFinTalk';
import AddFinStat from '../components/Admin/finstat/AddFinStat';
import EditDisclaimer from '../components/Admin/fintalk/EditDisclaimer.vue';
import EditStatDisclaimer from '../components/Admin/finstat/EditStatDisclaimer.vue';
import ListDisclaimer from '../components/Admin/fintalk/ListDisclaimer.vue';
import ListStatDisclaimer from '../components/Admin/finstat/ListStatDisclaimer.vue';
import ListFinTalk from '../components/Admin/fintalk/ListFinTalk';
import ListFinStat from '../components/Admin/finstat/ListFinStat';
import EditFinTalk from '../components/Admin/fintalk/EditFinTalk';
import EditFinStat from '../components/Admin/finstat/EditFinStat';
import ValueAddedServices from '../components/common/ValueAddedServices.vue';
import FinTalk from '../components/fintalk/FinTalk.vue';
import FinTalkArticles from '../components/fintalk/FinTalkArticles.vue';
import FinTalkCategory from '../components/fintalk/FinTalkCategory.vue';
import FinStat from '../components/finstat/FinStat.vue';
import FinStatCategory from '../components/finstat/FinStatCategory.vue';
import FinStatArticles from '../components/finstat/FinStatArticles.vue';
import ReadFintalkArticle from '../components/fintalk/ReadFintalkArticle.vue';
import ReadFinstatArticles from '../components/finstat/ReadFinstatArticles.vue';
import ReadFullArticles from '../components/fintalk/ReadFullArticles.vue';
import ReadFullFinstatArticle from '../components/finstat/ReadFullFinstatArticle.vue';
import MyWill from '../components/WillSection/MyWill.vue';
import StepsCreateWill from '../components/WillSection/StepsCreateWill.vue';
import WillPayment from '../components/WillSection/WillPayment.vue';
import WillCreation from '../components/WillSection/WillCreation.vue';
import MemberWillCreation from '../components/WillSection/MemberWillCreation.vue';

import MemberDetails from '../components/WillSection/MemberDetails.vue';
import AccountDetails from '../components/WillSection/AccountDetails.vue';
import LatestWill from '../components/WillSection/LatestWill.vue';
import Creation from '../components/WillSection/Creation.vue';
import BusinessDashboard from '../components/Admin/BusinessDashboard.vue';
import CustomerPayment from '../components/payment/CustomerPayment.vue';
import RegisterWill from '../components/WillSection/RegisterWill.vue';
import AddFintalkCategory from '../components/Admin/fintalkCategories/AddFintalkCategory';
import EditFintalkCategory from '../components/Admin/fintalkCategories/EditFintalkCategory.vue';
import ListFintalkCategory from '../components/Admin/fintalkCategories/ListFintalkCategory';
import AddFinstatCategory from '../components/Admin/finstatCategories/AddFinstatCategory';
import EditFinstatCategory from '../components/Admin/finstatCategories/EditFinstatCategory.vue';
import ListFinstatCategory from '../components/Admin/finstatCategories/ListFinstatCategory';
import ViewArticle from '../components/fintalk/viewArticle.vue';
import AdminBank from '../components/Admin/AdminBank.vue';
import UploadBankDetails from '../components/Admin/UploadBankDetails';
import EditBankDetails from '../components/Admin/EditBankDetails';
import ListPostOfcDetails from '../components/Admin/postoffice/ListPostOfcDetails.vue';
import AddPostOfcDetails from '../components/Admin/postoffice/AddPostOfcDetails';
import EditPostOfcDetails from '../components/Admin/postoffice/EditPostOfcDetails';
import AssignPromoCode from '../components/Admin/discount/AssignPromoCode.vue';
import PromoCode from '../components/Admin/discount/PromoCode.vue';
import MasterIndex from '../components/Admin/masters/index.vue';
import StockBrockers from '../components/Admin/masters/StockBrockers.vue';
import ListingAIF from '../components/Admin/masters/ListingAIF.vue';
import RealEstate from '../components/Admin/masters/RealEstate.vue';
import DPparticipants from '../components/Admin/masters/DPparticipants.vue';
import PMS from '../components/Admin/masters/PMS.vue';
import Insurance from '../components/Admin/masters/Insurance.vue';
import PensionFund from '../components/Admin/masters/PensionFund.vue';
import AnnuityPlans from '../components/Admin/masters/AnnuityPlans.vue';
import Banks from '../components/Admin/masters/Banks.vue';
import Bullion from '../components/Admin/masters/Bullion.vue';
import Nbfc from '../components/Admin/masters/Nbfc.vue';
import LifeInsurancePolicy from '../components/Admin/masters/LifeInsurancePolicy.vue';
import GroupInsurancePolicy from '../components/Admin/masters/GroupInsurancePolicy.vue';
import NonLifeInsurancePolicy from '../components/Admin/masters/NonLifeInsurancePolicy.vue';
import DigitalGoldCompany from '../components/Admin/masters/DigitalGoldCompany.vue';
import WillPrice from '../components/Admin/masters/WillPrice.vue';
import ProtectoMeterForm from '../components/ValueAddedServices/GoalSure/ProtectoMeterForm.vue';
import RetiroMeterForm from '../components/ValueAddedServices/GoalSure/RetiroMeterForm.vue';
import EduMeterForm from '../components/ValueAddedServices/GoalSure/EduMeterForm.vue';

import riskometerMaster from '../components/Admin/masters/riskometer.vue';
import protectometerMaster from '../components/Admin/masters/protectometer.vue';



import SudLifeFinTalk from '../components/sudlife-client/fintalk/FinTalk.vue';
import SudLifeFinTalkArticles from '../components/sudlife-client/fintalk/FinTalkArticles.vue';
import SudLifeFinTalkCategory from '../components/sudlife-client/fintalk/FinTalkCategory.vue';
import SudLifeFinStat from '../components/sudlife-client/finstat/FinStat.vue';
import SudLifeFinStatCategory from '../components/sudlife-client/finstat/FinStatCategory.vue';
import SudLifeFinStatArticles from '../components/sudlife-client/finstat/FinStatArticles.vue';
import SudLifeReadFintalkArticle from '../components/sudlife-client/fintalk/ReadFintalkArticle.vue';
import SudLifeReadFinstatArticles from '../components/sudlife-client/finstat/ReadFinstatArticles.vue';
import SudLifeReadFullArticles from '../components/sudlife-client/fintalk/ReadFullArticles.vue';
import SudLifeReadFullFinstatArticle from '../components/sudlife-client/finstat/ReadFullFinstatArticle.vue';






import { Auth } from 'aws-amplify';
import {
  GET_PROFILE_DETAIL,
  GET_REFERRAL_DETAIL,
  USER_SIGNOUT,
  USER_DETAILS,
} from '../store/actions.type';
import JwtService from '.././common/jwt.service';

Vue.filter('formatDate', function (value, format) {
  if (value) {
    return moment(String(value)).format(format);
  }
});

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'Login',
    component: Login,
    meta: { isPublic: true, requiresAuth: false, isHeader: false },
  },
  {
    path: '/signup',
    name: 'Register',
    component: Register,
    meta: { isPublic: true, requiresAuth: false, isHeader: false },
  },
  {
    path: '/fin-dashboard',
    name: 'SudLifeLandingPage',
    component: SudLifeLandingPage,
    meta: { isPublic: true, requiresAuth: false, isHeader: false },
  },
  {
    path: '/user-otp-verification',
    name: 'SudLifeUserVerifyOtp',
    component: SudLifeUserVerifyOtp,
    meta: { isPublic: true, requiresAuth: false, isHeader: false },
  },
  {
    path: '/admin',
    name: 'LoginLayout',
    component: LoginLayout,
    meta: { isAdmin: true, preLogin: true },
  },
  {
    path: '/admin/StockBrockers',
    name: 'StockBrockers',
    component: StockBrockers,
    meta: { isAdmin: true, menu: 'StockBrockers' },
  },
  {
    path: '/admin/AnnuityPlans',
    name: 'AnnuityPlans',
    component: AnnuityPlans,
    meta: { isAdmin: true, menu: 'AnnuityPlans' },
  },
  {
    path: '/admin/riskometer',
    name: 'riskometerMaster',
    component: riskometerMaster,
    meta: { isAdmin: true, menu: 'riskometerMaster' },
  },
  {
    path: '/admin/protectometer',
    name: 'protectometerMaster',
    component: protectometerMaster,
    meta: { isAdmin: true, menu: 'protectometerMaster' },
  },
  {
    path: '/admin/Banks',
    name: 'Banks',
    component: Banks,
    meta: { isAdmin: true, menu: 'Banks' },
  },
  {
    path: '/admin/PortfolioManager-AIF',
    name: 'ListingAIF',
    component: ListingAIF,
    meta: { isAdmin: true, menu: 'ListingAIF' },
  },
  {
    path: '/admin/RealEstate',
    name: 'RealEstate',
    component: RealEstate,
    meta: { isAdmin: true, menu: 'RealEstate' },
  },
  {
    path: '/admin/MasterIndex',
    name: 'MasterIndex',
    component: MasterIndex,
    meta: { isAdmin: true, menu: 'MasterIndex' },
  },
  {
    path: '/admin/DPparticipants',
    name: 'DPparticipants',
    component: DPparticipants,
    meta: { isAdmin: true, menu: 'DPparticipants' },
  },
  {
    path: '/admin/PMS',
    name: 'PMS',
    component: PMS,
    meta: { isAdmin: true, menu: 'PMS' },
  },
  {
    path: '/admin/Insurance',
    name: 'Insurance',
    component: Insurance,
    meta: { isAdmin: true, menu: 'Insurance' },
  },
  {
    path: '/admin/PensionFund',
    name: 'PensionFund',
    component: PensionFund,
    meta: { isAdmin: true, menu: 'PensionFund' },
  },
  {
    path: '/admin/Bullion',
    name: 'Bullion',
    component: Bullion,
    meta: { isAdmin: true, menu: 'Bullion' },
  },
  {
    path: '/admin/LifeInsurancePolicy',
    name: 'LifeInsurancePolicy',
    component: LifeInsurancePolicy,
    meta: { isAdmin: true, menu: 'LifeInsurancePolicy' },
  },
  {
    path: '/admin/GroupInsurancePolicy',
    name: 'GroupInsurancePolicy',
    component: GroupInsurancePolicy,
    meta: { isAdmin: true, menu: 'GroupInsurancePolicy' },
  },
  {
    path: '/admin/NonLifeInsurancePolicy',
    name: 'NonLifeInsurancePolicy',
    component: NonLifeInsurancePolicy,
    meta: { isAdmin: true, menu: 'NonLifeInsurancePolicy' },
  },
  {
    path: '/admin/DigitalGoldCompany',
    name: 'DigitalGoldCompany',
    component: DigitalGoldCompany,
    meta: { isAdmin: true, menu: 'DigitalGoldCompany' },
  },
  {
    path: '/admin/WillPrice',
    name: 'WillPrice',
    component: WillPrice,
    meta: { isAdmin: true, menu: 'WillPrice' },
  },
  {
    path: '/admin/Nbfc',
    name: 'Nbfc',
    component: Nbfc,
    meta: { isAdmin: true, menu: 'Nbfc' },
  },
  {
    path: '/admin/dashboard',
    name: 'AdminDashboard',
    component: AdminDashboard,
    meta: { isAdmin: true, menu: 'dashboard' },
  },
  {
    path: '/admin/businessdashboard',
    name: 'BusinessDashboard',
    component: BusinessDashboard,
    meta: { isAdmin: true, menu: 'business-dashboard' },
  },
  {
    path: '/admin/campaigns',
    name: 'AdminCampaign',
    component: AdminCampaign,
    meta: { isAdmin: true, menu: 'campaigns' },
  },
  {
    path: '/admin/add-campaign',
    name: 'AddCampaign',
    component: AddCampaign,
    meta: { isAdmin: true, menu: 'campaigns' },
  },
  {
    path: '/admin/edit-campaign/:id',
    name: 'EditCampaign',
    component: EditCampaign,
    meta: { isAdmin: true, menu: 'campaigns' },
  },
  {
    path: '/admin/CampaignTopic',
    name: 'CampaignTopic',
    component: CampaignTopic,
    meta: { isAdmin: true, menu: 'campaigntopic' },
  },
  {
    path: '/admin/CampaignTopicForm',
    name: 'CampaignTopicForm',
    component: CampaignTopicForm,
    meta: { isAdmin: true, menu: 'campaigntopic' },
  },
  {
    path: '/admin/edit-campaign-topic/:id',
    name: 'EditCampaignTopic',
    component: EditCampaignTopic,
    meta: { isAdmin: true, menu: 'campaigntopic' },
  },
  {
    path: '/admin/settings',
    name: 'Settings',
    component: Settings,
    meta: { isAdmin: true, menu: 'settings' },
  },
  {
    path: '/admin/settings/Edit_list/:id',
    name: 'Edit_list',
    component: Edit_list,
    meta: { isAdmin: true, menu: 'settings' },
  },
  {
    path: '/admin/users/:name',
    name: 'Users',
    props: true,
    component: Users,
    meta: { isAdmin: true, menu: 'users' },
  },
  {
    path: '/admin/banks',
    name: 'AdminBank',
    component: AdminBank,
    meta: { isAdmin: true, menu: 'banks' },
  },
  {
    path: '/admin/upload_file',
    name: 'UploadBankDetails',
    component: UploadBankDetails,
    meta: { isAdmin: true, menu: 'banks' },
  },
  // {
  //   path: '/admin/edit-details/:id',
  //   name: 'EditBankDetails',
  //   component: EditBankDetails,
  //   meta: { isAdmin: true, menu: 'banks' },
  // },
  {
    path: '/admin/subscription',
    name: 'SubscriptionPlan',
    component: SubscriptionPlan,
    meta: { isAdmin: true, menu: 'subscription' },
  },
  {
    path: '/admin/subscription/EditList/:id',
    name: 'EditList',
    component: EditList,
    meta: { isAdmin: true, menu: 'subscription' },
  },
  {
    path: '/admin/discount',
    name: 'DiscountRate',
    component: DiscountRate,
    meta: { isAdmin: true, menu: 'discount' },
  },
  {
    path: '/admin/discount/Add_Rate',
    name: 'AddRate',
    component: AddRate,
    meta: { isAdmin: true, menu: 'discount' },
  },
  {
    path: '/admin/discount/EditRate/:id',
    name: 'EditRate',
    component: EditRate,
    meta: { isAdmin: true, menu: 'discount' },
  },
  {
    path: '/admin/EditWillCoupon/:id',
    name: 'EditWillCoupon',
    component: EditWillCoupon,
    meta: { isAdmin: true, menu: 'will-discount' },
  },
  {
    path: '/admin/ListWillCoupon',
    name: 'ListWillCoupon',
    component: ListWillCoupon,
    meta: { isAdmin: true, menu: 'will-discount' },
  },
  {
    path: '/admin/AddWillCoupon',
    name: 'AddWillCoupon',
    component: AddWillCoupon,
    meta: { isAdmin: true, menu: 'will-discount' },
  },
  {
    path: '/admin/most-visited-page',
    name: 'MostVisitedPage',
    props: true,
    component: MostVisitedPage,
    meta: { isAdmin: true, menu: 'mostvisited' },
  },
  {
    path: '/admin/AddFinTalk',
    name: 'AddFinTalk',
    props: true,
    component: AddFinTalk,
    meta: { isAdmin: true, menu: 'fintalk' },
  },
  {
    path: '/admin/edit-fintalk-disclaimer/:id',
    name: 'EditDisclaimer',
    props: true,
    component: EditDisclaimer,
    meta: { isAdmin: true, menu: 'disclaimer' },
  },
  {
    path: '/admin/fintalk-disclaimer',
    name: 'ListDisclaimer',
    props: true,
    component: ListDisclaimer,
    meta: { isAdmin: true, menu: 'disclaimer' },
  },
  {
    path: '/admin/fintalks',
    name: 'ListFinTalk',
    props: true,
    component: ListFinTalk,
    meta: { isAdmin: true, menu: 'fintalk' },
  },
  {
    path: '/admin/edit-fintalk/:id',
    name: 'EditFinTalk',
    props: true,
    component: EditFinTalk,
    meta: { isAdmin: true, menu: 'fintalk' },
  },
  {
    path: '/admin/AddFinStat',
    name: 'AddFinStat',
    props: true,
    component: AddFinStat,
    meta: { isAdmin: true, menu: 'finstat' },
  },
  {
    path: '/admin/AssignPromoCode',
    name: 'AssignPromoCode',
    props: true,
    component: AssignPromoCode,
    meta: { isAdmin: true, menu: 'AssignPromoCode' },
  },
  {
    path: '/admin/edit-finstat-disclaimer/:id',
    name: 'EditStatDisclaimer',
    props: true,
    component: EditStatDisclaimer,
    meta: { isAdmin: true, menu: 'disclaimer' },
  },
  {
    path: '/admin/finstat-disclaimer',
    name: 'ListStatDisclaimer',
    props: true,
    component: ListStatDisclaimer,
    meta: { isAdmin: true, menu: 'disclaimer' },
  },
  {
    path: '/admin/finstat',
    name: 'ListFinStat',
    props: true,
    component: ListFinStat,
    meta: { isAdmin: true, menu: 'finstat' },
  },
  {
    path: '/admin/edit-finstat/:id',
    name: 'EditFinStat',
    props: true,
    component: EditFinStat,
    meta: { isAdmin: true, menu: 'finstat' },
  },
  {
    path: '/admin/AddFinTalkCategory',
    name: 'AddFintalkCategory',
    props: true,
    component: AddFintalkCategory,
    meta: { isAdmin: true, menu: 'fintalkCategories' },
  },
  {
    path: '/admin/fintalkcategories',
    name: 'ListFintalkCategory',
    props: true,
    component: ListFintalkCategory,
    meta: { isAdmin: true, menu: 'fintalkCategories' },
  },
  {
    path: '/admin/edit-fintalkcategory/:id',
    name: 'EditFintalkCategory',
    props: true,
    component: EditFintalkCategory,
    meta: { isAdmin: true, menu: 'fintalkCategories' },
  },
  {
    path: '/admin/AddFinStatCategory',
    name: 'AddFinstatCategory',
    props: true,
    component: AddFinstatCategory,
    meta: { isAdmin: true, menu: 'finstatCategories' },
  },
  {
    path: '/admin/edit-finstatcategory/:id',
    name: 'EditFinstatCategory',
    props: true,
    component: EditFinstatCategory,
    meta: { isAdmin: true, menu: 'finstatCategories' },
  },
  {
    path: '/admin/finstatcategories',
    name: 'ListFinstatCategory',
    props: true,
    component: ListFinstatCategory,
    meta: { isAdmin: true, menu: 'finstatCategories' },
  },
  {
    path: '/admin/post-office',
    name: 'ListPostOfcDetails',
    props: true,
    component: ListPostOfcDetails,
    meta: { isAdmin: true, menu: 'postoffice' },
  },
  {
    path: '/admin/add-details',
    name: 'AddPostOfcDetails',
    props: true,
    component: AddPostOfcDetails,
    meta: { isAdmin: true, menu: 'postoffice' },
  },
  {
    path: '/admin/EditPostOfcDetails/:id',
    name: 'EditPostOfcDetails',
    props: true,
    component: EditPostOfcDetails,
    meta: { isAdmin: true, menu: 'postoffice' },
  },
  {
    path: '/VerifyOtp',
    name: 'VerifyOtp',
    component: VerifyOtp,
    meta: { isPublic: true, requiresAuth: false, isHeader: false },
  },
  {
    path: '/Dashboard',
    name: 'dashboard',
    component: Dashboard,
    meta: {
      isPublic: false,
      requiresAuth: true,
      siderBarMenu: 5,
      isHeader: false,
    },
  },
  {
    path: '/Forgotpassword',
    name: 'Forgotpassword',
    component: Forgotpassword,
    meta: { isPublic: true, requiresAuth: false, isHeader: false },
  },
  {
    path: '/ConfirmNewPassword',
    name: 'ConfirmNewPassword',
    component: ConfirmNewPassword,
    meta: { isPublic: true, requiresAuth: false, isHeader: false },
  },
  {
    path: '/Changepassword',
    name: 'Changepassword',
    component: Changepassword,
    meta: {
      isPublic: true,
      requiresAuth: true,
      isHeader: false,
      siderBarMenu: 5,
    },
  },
  {
    path: '/SetupNewPassword',
    name: 'SetupNewPassword',
    component: SetupNewPassword,
    meta: {
      isPublic: true,
      requiresAuth: true,
      isHeader: false,
      siderBarMenu: 5,
    },
  },
  {
    path: '/EditProfile',
    name: 'EditProfile',
    component: EditProfile,
    meta: {
      isPublic: false,
      requiresAuth: true,
      isHeader: false,
      siderBarMenu: 5,
    },
  },
  {
    path: '/VerifyMobileOtp',
    name: 'VerifyMobileOtp',
    component: VerifyMobileOtp,
    meta: { isPublic: true, requiresAuth: false, isHeader: false },
  },
  {
    path: '/ConfirmPasswordOtp',
    name: 'ConfirmPasswordOtp',
    component: VerifyMobileOtp,
    meta: { isPublic: true, requiresAuth: false, isHeader: false },
  },
  {
    path: '/Investometer',
    name: 'Investometer',
    component: Investometer,
    meta: {
      isPublic: false,
      requiresAuth: true,
      siderBarMenu: 0,
      isHeader: false,
    },
  },
  {
    path: '/RewardsPoint',
    name: 'RewardsPoint',
    component: RewardsPoint,
    meta: {
      isPublic: false,
      requiresAuth: true,
      isHeader: false,
      siderBarMenu: 5,
    },
  },
  {
    path: '/ContactUsForm',
    name: 'ContactUsForm',
    component: ContactUsForm,
    meta: {
      isPublic: false,
      requiresAuth: true,
      siderBarMenu: 6,
      isHeader: false,
    },
  },
  {
    path: '/AddNewMember',
    name: 'AddNewMember',
    component: AddNewMember,
    meta: {
      isPublic: false,
      requiresAuth: true,
      isHeader: false,
      siderBarMenu: 5,
    },
  },
  // {
  //  path: '/razorpay',
  //  name: 'razorpay',
  //  component: razorpay,
  //  meta: { isPublic: false,requiresAuth: true}
  // },
  {
    path: '/EditNewMember/:editId',
    name: 'EditNewMember',
    component: EditNewMember,
    meta: {
      isPublic: false,
      requiresAuth: true,
      isHeader: false,
      siderBarMenu: 5,
    },
  },
  {
    path: '/congratulations',
    name: 'congratulations',
    component: congratulations,
    meta: { isPublic: true, requiresAuth: true, isHeader: true },
  },
  
  {
    path: '/admin/PromoCode',
    name: 'PromoCode',
    props: true,
    component: PromoCode,
    meta: { isAdmin: true, menu: 'PromoCode' },
  },
  {
    path: '/pricingPlan',
    name: 'pricingPlan',
    component: pricingPlan,
    meta: { isPublic: true, requiresAuth: true, isHeader: true },
  },
  {
    path: '/PaymentDetail',
    name: 'PaymentDetail',
    component: PaymentDetail,
    meta: { isPublic: true, requiresAuth: true, isHeader: true },
  },
  {
    path: '/ChooseOption',
    name: 'ChooseOption',
    component: ChooseOption,
    meta: { isPublic: true, requiresAuth: true, isHeader: true },
  },
  {
    path: '/SubscriptionCongratulations',
    name: 'SubscriptionCongratulations',
    component: SubscriptionCongratulations,
    meta: { isPublic: true, requiresAuth: true, isHeader: true },
  },
  {
    path: '/Myplan',
    name: 'Myplan',
    component: Myplan,
    meta: { isPublic: false, requiresAuth: true, isHeader: false },
  },
  {
    path: '/CorsComponent',
    name: 'CorsComponent',
    component: CorsComponent,
    meta: { isPublic: false, requiresAuth: true, isHeader: false },
  },
  {
    path: '/Investment',
    name: 'Investment',
    component: Investment,
    meta: {
      isPublic: false,
      requiresAuth: true,
      isHeader: false,
      siderBarMenu: 1,
    },
  },
  {
    path: '/SubCategory',
    name: 'SubCategory',
    component: SubCategory,
    meta: {
      isPublic: false,
      requiresAuth: true,
      isHeader: false,
      siderBarMenu: 1,
    },
  },
  {
    path: '/SavingComponent',
    name: 'SavingComponent',
    component: SavingComponent,
    meta: {
      isPublic: false,
      requiresAuth: true,
      isHeader: false,
      siderBarMenu: 1,
    },
  },
  {
    path: '/deposit-dashboard/:tab?',
    name: 'deposit-dashboard',
    component: DepositeDashboard,
    meta: {
      isPublic: false,
      requiresAuth: true,
      isHeader: false,
      siderBarMenu: 1,
    },
  },
  {
    path: '/sukanya-samriddhi-yogna',
    name: 'SukanyaSamriddhiYogna',
    component: SukanyaSamriddhiYogna,
    meta: {
      isPublic: false,
      requiresAuth: true,
      isHeader: false,
      siderBarMenu: 1,
    },
  },
  {
    path: '/fixed-deposit',
    name: 'FixedDeposit',
    component: FixedDeposit,
    meta: {
      isPublic: false,
      requiresAuth: true,
      isHeader: false,
      siderBarMenu: 1,
    },
  },
  {
    path: '/recurring-deposits',
    name: 'RecurringDeposits',
    component: RecurringDeposits,
    meta: {
      isPublic: false,
      requiresAuth: true,
      isHeader: false,
      siderBarMenu: 1,
    },
  },
  {
    path: '/edit-saving-accounts/:id',
    name: 'EditSavingAccounts',
    component: EditSavingAccounts,
    meta: {
      isPublic: false,
      requiresAuth: true,
      isHeader: false,
      siderBarMenu: 1,
    },
  },
  {
    path: '/edit-fixed-deposit/:id',
    name: 'EditFixedDeposit',
    component: EditFixedDeposit,
    meta: {
      isPublic: false,
      requiresAuth: true,
      isHeader: false,
      siderBarMenu: 1,
    },
  },
  {
    path: '/edit-sukanya-samriddhi-yogna/:id',
    name: 'EditSukanyaSamriddhiYogna',
    component: EditSukanyaSamriddhiYogna,
    meta: {
      isPublic: false,
      requiresAuth: true,
      isHeader: false,
      siderBarMenu: 1,
    },
  },
  {
    path: '/edit-recurring-deposite/:id',
    name: 'EditRecurringDeposite',
    component: EditRecurringDeposite,
    meta: {
      isPublic: false,
      requiresAuth: true,
      isHeader: false,
      siderBarMenu: 1,
    },
  },
  {
    path: '/mutual-fund-dashboard',
    name: 'mutual-dashboard',
    component: MutualFundsDasboard,
    meta: {
      isPublic: false,
      requiresAuth: true,
      isHeader: false,
      siderBarMenu: 1,
    },
  },
  {
    path: '/add-lumpsum-investment',
    name: 'AddLumpsumInvestment',
    component: AddLumpsumInvestment,
    meta: {
      isPublic: false,
      requiresAuth: true,
      isHeader: false,
      siderBarMenu: 1,
    },
  },
  {
    path: '/add-systematic-investment-plan',
    name: 'AddSystematicInvestmentPlan',
    component: AddSystematicInvestmentPlan,
    meta: {
      isPublic: false,
      requiresAuth: true,
      isHeader: false,
      siderBarMenu: 1,
    },
  },
  {
    path: '/edit-lumpsum-investment/:editId/:tabId',
    name: 'EditLumpsumInvestment',
    component: EditLumpsumInvestment,
    meta: {
      isPublic: false,
      requiresAuth: true,
      isHeader: false,
      siderBarMenu: 1,
    },
  },
  {
    path: '/edit-systematic-investment-plan/:editId/:tabId',
    name: 'EditSystematicInvestmentPlan',
    component: EditSystematicInvestmentPlan,
    meta: {
      isPublic: false,
      requiresAuth: true,
      isHeader: false,
      siderBarMenu: 1,
    },
  },
  {
    path: '/equities-dashboard/:tab?',
    name: 'equities-dashboard',
    component: EquitiesDashboard,
    meta: {
      isPublic: false,
      requiresAuth: true,
      isHeader: false,
      siderBarMenu: 1,
    },
  },
  {
    path: '/add-equities',
    name: 'add-equities',
    component: AddEquities,
    meta: {
      isPublic: false,
      requiresAuth: true,
      isHeader: false,
      siderBarMenu: 1,
    },
  },
  {
    path: '/add-exchange-traded-fund',
    name: 'add-exchange-traded-fund',
    component: AddExchangeTradedFund,
    meta: {
      isPublic: false,
      requiresAuth: true,
      isHeader: false,
      siderBarMenu: 1,
    },
  },
  {
    path: '/add-bonds',
    name: 'add-bonds',
    component: AddBonds,
    meta: {
      isPublic: false,
      requiresAuth: true,
      isHeader: false,
      siderBarMenu: 1,
    },
  },
  {
    path: '/edit-equities/:id',
    name: 'edit-equities',
    component: EditEquities,
    meta: {
      isPublic: false,
      requiresAuth: true,
      isHeader: false,
      siderBarMenu: 1,
    },
  },
  {
    path: '/edit-exchange-traded-fund/:id',
    name: 'edit-exchange-traded-fund',
    component: EditExchangeTradedFund,
    meta: {
      isPublic: false,
      requiresAuth: true,
      isHeader: false,
      siderBarMenu: 1,
    },
  },
  {
    path: '/edit-bond/:id',
    name: 'edit-bond',
    component: EditBonds,
    meta: {
      isPublic: false,
      requiresAuth: true,
      isHeader: false,
      siderBarMenu: 1,
    },
  },
  {
    path: '/accounts-dashboard',
    name: 'accounts-dashboard',
    component: AccountsDashboard,
    meta: {
      isPublic: false,
      requiresAuth: true,
      isHeader: false,
      siderBarMenu: 4,
    },
  },
  {
    path: '/accounts-subcategory',
    name: 'accounts-subcategory',
    component: AccountsSubCategory,
    meta: {
      isPublic: false,
      requiresAuth: true,
      isHeader: false,
      siderBarMenu: 4,
    },
  },
  {
    path: '/add-demat',
    name: 'add-demat',
    component: AddDemat,
    meta: {
      isPublic: false,
      requiresAuth: true,
      isHeader: false,
      siderBarMenu: 4,
    },
  },
  {
    path: '/demat-edit/:id',
    name: 'demat-edit',
    component: EditDemat,
    meta: {
      isPublic: false,
      requiresAuth: true,
      isHeader: false,
      siderBarMenu: 4,
    },
  },
  {
    path: '/add-trading',
    name: 'add-trading',
    component: AddTrading,
    meta: {
      isPublic: false,
      requiresAuth: true,
      isHeader: false,
      siderBarMenu: 4,
    },
  },
  {
    path: '/trading-edit/:id',
    name: 'trading-edit',
    component: EditTrading,
    meta: {
      isPublic: false,
      requiresAuth: true,
      isHeader: false,
      siderBarMenu: 4,
    },
  },
  {
    path: '/add-e-insurance',
    name: 'add-e-insurance',
    component: AddEInsurance,
    meta: {
      isPublic: false,
      requiresAuth: true,
      isHeader: false,
      siderBarMenu: 4,
    },
  },
  {
    path: '/e-insurance-edit/:id',
    name: 'e-insurance-edit',
    component: EditEInsurance,
    meta: {
      isPublic: false,
      requiresAuth: true,
      isHeader: false,
      siderBarMenu: 4,
    },
  },

  {
    path: '/liabilities-dashboard',
    name: 'liabilities-dashboard',
    component: LiabilitiesDashboard,
    meta: {
      isPublic: false,
      requiresAuth: true,
      isHeader: false,
      siderBarMenu: 2,
    },
  },
  {
    path: '/add-home-loan',
    name: 'add-home-loan',
    component: homeLoanAdd,
    meta: {
      isPublic: false,
      requiresAuth: true,
      isHeader: false,
      siderBarMenu: 2,
    },
  },
  {
    path: '/liabilities-subcategory',
    name: 'liabilities-subcategory',
    component: LiabilitiesSubCategory,
    meta: {
      isPublic: false,
      requiresAuth: true,
      isHeader: false,
      siderBarMenu: 2,
    },
  },
  {
    path: '/personal-loan-add',
    name: 'personal-loan-add',
    component: personalLoanAdd,
    meta: {
      isPublic: false,
      requiresAuth: true,
      isHeader: false,
      siderBarMenu: 2,
    },
  },
  {
    path: '/home-loan-edit/:id',
    name: 'home-loan-edit',
    component: homeLoanEdit,
    meta: {
      isPublic: false,
      requiresAuth: true,
      isHeader: false,
      siderBarMenu: 2,
    },
  },
  {
    path: '/personal-loan-edit/:id',
    name: 'personal-loan-edit',
    component: personalLoanEdit,
    meta: {
      isPublic: false,
      requiresAuth: true,
      isHeader: false,
      siderBarMenu: 2,
    },
  },
  {
    path: '/consumer-loan-add',
    name: 'consumer-loan-add',
    component: consumerLoanAdd,
    meta: {
      isPublic: false,
      requiresAuth: true,
      isHeader: false,
      siderBarMenu: 2,
    },
  },
  {
    path: '/consumer-loan-edit/:id',
    name: 'consumer-loan-edit',
    component: ConsumerLoanEdit,
    meta: {
      isPublic: false,
      requiresAuth: true,
      isHeader: false,
      siderBarMenu: 2,
    },
  },
  {
    path: '/student-loan-add',
    name: 'student-loan-add',
    component: StudentLoanAdd,
    meta: {
      isPublic: false,
      requiresAuth: true,
      isHeader: false,
      siderBarMenu: 2,
    },
  },
  {
    path: '/student-loan-edit/:id',
    name: 'student-loan-edit',
    component: StudentLoanEdit,
    meta: {
      isPublic: false,
      requiresAuth: true,
      isHeader: false,
      siderBarMenu: 2,
    },
  },
  {
    path: '/car-loan-add',
    name: 'car-loan-add',
    component: AddCarLoan,
    meta: {
      isPublic: false,
      requiresAuth: true,
      isHeader: false,
      siderBarMenu: 2,
    },
  },
  {
    path: '/car-loan-edit/:id',
    name: 'car-loan-edit',
    component: EditCarLoan,
    meta: {
      isPublic: false,
      requiresAuth: true,
      isHeader: false,
      siderBarMenu: 2,
    },
  },
  {
    path: '/two-wheeler-add',
    name: 'two-wheeler-add',
    component: AddTwoWheelerLoan,
    meta: {
      isPublic: false,
      requiresAuth: true,
      isHeader: false,
      siderBarMenu: 2,
    },
  },
  {
    path: '/two-wheeler-edit/:id',
    name: 'two-wheeler-edit',
    component: EditTwoWheelerLoan,
    meta: {
      isPublic: false,
      requiresAuth: true,
      isHeader: false,
      siderBarMenu: 2,
    },
  },
  {
    path: '/add-over-draft',
    name: 'add-over-draft',
    component: AddOverDraft,
    meta: {
      isPublic: false,
      requiresAuth: true,
      isHeader: false,
      siderBarMenu: 2,
    },
  },
  {
    path: '/edit-over-draft/:id',
    name: 'edit-over-draft',
    component: EditOverDraft,
    meta: {
      isPublic: false,
      requiresAuth: true,
      isHeader: false,
      siderBarMenu: 2,
    },
  },
  {
    path: '/add-policy-loan',
    name: 'add-policy-loan',
    component: AddPolicyLoan,
    meta: {
      isPublic: false,
      requiresAuth: true,
      isHeader: false,
      siderBarMenu: 2,
    },
  },
  {
    path: '/edit-policy-loan/:id',
    name: 'edit-policy-loan',
    component: EditPolicyLoan,
    meta: {
      isPublic: false,
      requiresAuth: true,
      isHeader: false,
      siderBarMenu: 2,
    },
  },
  {
    path: '/add-loan-against-property',
    name: 'add-loan-against-property',
    component: AddLoanAgainstProperty,
    meta: {
      isPublic: false,
      requiresAuth: true,
      isHeader: false,
      siderBarMenu: 2,
    },
  },
  {
    path: '/edit-loan-against-property/:id',
    name: 'edit-loan-against-property',
    component: EditLoanAgainstProperty,
    meta: {
      isPublic: false,
      requiresAuth: true,
      isHeader: false,
      siderBarMenu: 2,
    },
  },
  {
    path: '/add-credit-card-laon',
    name: 'add-credit-card-laon',
    component: AddCreditCardLoan,
    meta: {
      isPublic: false,
      requiresAuth: true,
      isHeader: false,
      siderBarMenu: 2,
    },
  },
  {
    path: '/edit-credit-card/:id',
    name: 'edit-credit-card',
    component: EditCreditCard,
    meta: {
      isPublic: false,
      requiresAuth: true,
      isHeader: false,
      siderBarMenu: 2,
    },
  },
  {
    path: '/add-bars_and_coins',
    name: 'add-bars_and_coins',
    component: AddBarsAndCoins,
    meta: {
      isPublic: false,
      requiresAuth: true,
      isHeader: false,
      siderBarMenu: 1,
    },
  },
  {
    path: '/bullions-dashboard/:tab?',
    name: 'bullions-dashboard',
    component: BullionsDashboards,
    meta: {
      isPublic: false,
      requiresAuth: true,
      isHeader: false,
      siderBarMenu: 1,
    },
  },
  {
    path: '/add-jwellery',
    name: 'add-jwellery',
    component: AddJewellery,
    meta: {
      isPublic: false,
      requiresAuth: true,
      isHeader: false,
      siderBarMenu: 1,
    },
  },
  {
    path: '/add-digital-gold',
    name: 'add-digital-gold',
    component: AddDigitalGold,
    meta: {
      isPublic: false,
      requiresAuth: true,
      isHeader: false,
      siderBarMenu: 1,
    },
  },
  {
    path: '/add-gold-bonds',
    name: 'add-gold-bonds',
    component: AddGoldBonds,
    meta: {
      isPublic: false,
      requiresAuth: true,
      isHeader: false,
      siderBarMenu: 1,
    },
  },
  {
    path: '/edit-bars-coins/:id',
    name: 'edit-bars-coins',
    component: EditBarsAndCoins,
    meta: {
      isPublic: false,
      requiresAuth: true,
      isHeader: false,
      siderBarMenu: 1,
    },
  },
  {
    path: '/edit-digital-gold/:id',
    name: 'edit-digital-gold',
    component: EditDigitalGold,
    meta: {
      isPublic: false,
      requiresAuth: true,
      isHeader: false,
      siderBarMenu: 1,
    },
  },
  {
    path: '/edit-gold-bonds/:id',
    name: 'edit-gold-bonds',
    component: EditGoldBonds,
    meta: {
      isPublic: false,
      requiresAuth: true,
      isHeader: false,
      siderBarMenu: 1,
    },
  },
  {
    path: '/edit-jewellery/:id',
    name: 'edit-jewellery',
    component: EditJewellery,
    meta: {
      isPublic: false,
      requiresAuth: true,
      isHeader: false,
      siderBarMenu: 1,
    },
  },
  {
    path: '/add-commodities',
    name: 'add-commodities',
    component: AddCommodities,
    meta: {
      isPublic: false,
      requiresAuth: true,
      isHeader: false,
      siderBarMenu: 1,
    },
  },
  {
    path: '/edit-commodities/:id',
    name: 'edit-commodities',
    component: EditCommodities,
    meta: {
      isPublic: false,
      requiresAuth: true,
      isHeader: false,
      siderBarMenu: 1,
    },
  },
  {
    path: '/commodities-dashboard',
    name: 'commodities-dashboard',
    component: CommoditiesDashboard,
    meta: {
      isPublic: false,
      requiresAuth: true,
      isHeader: false,
      siderBarMenu: 1,
    },
  },
  {
    path: '/retirement-dashboard',
    name: 'retirement-dashboard',
    component: RetirementDashboard,
    meta: {
      isPublic: false,
      requiresAuth: true,
      isHeader: false,
      siderBarMenu: 1,
    },
  },
  {
    path: '/add-annuity-scheme',
    name: 'add-annuity-scheme',
    component: AddAnnuityScheme,
    meta: {
      isPublic: false,
      requiresAuth: true,
      isHeader: false,
      siderBarMenu: 1,
    },
  },
  {
    path: '/edit-annuity-scheme/:id',
    name: 'edit-annuity-scheme',
    component: EditAnnuityScheme,
    meta: {
      isPublic: false,
      requiresAuth: true,
      isHeader: false,
      siderBarMenu: 1,
    },
  },
  {
    path: '/add-employee-provident-fund',
    name: 'add-employee-provident-fund',
    component: AddEmployeeProvidentFund,
    meta: {
      isPublic: false,
      requiresAuth: true,
      isHeader: false,
      siderBarMenu: 1,
    },
  },
  {
    path: '/edit-employee-provident-fund/:id',
    name: 'edit-employee-provident-fund',
    component: EditEmployeeProvidentFund,
    meta: {
      isPublic: false,
      requiresAuth: true,
      isHeader: false,
      siderBarMenu: 1,
    },
  },
  {
    path: '/add-monthly-scheme',
    name: 'add-monthly-scheme',
    component: AddMonthlyIncomeScheme,
    meta: {
      isPublic: false,
      requiresAuth: true,
      isHeader: false,
      siderBarMenu: 1,
    },
  },
  {
    path: '/edit-monthly-scheme/:id',
    name: 'edit-monthly-scheme',
    component: EditMonthlyIncomeScheme,
    meta: {
      isPublic: false,
      requiresAuth: true,
      isHeader: false,
      siderBarMenu: 1,
    },
  },
  {
    path: '/add-national-pension-scheme',
    name: 'add-national-pension-scheme',
    component: AddNationalPensionScheme,
    meta: {
      isPublic: false,
      requiresAuth: true,
      isHeader: false,
      siderBarMenu: 1,
    },
  },
  {
    path: '/edit-national-pension-scheme/:id',
    name: 'edit-national-pension-scheme',
    component: EditNationalPensionScheme,
    meta: {
      isPublic: false,
      requiresAuth: true,
      isHeader: false,
      siderBarMenu: 1,
    },
  },
  {
    path: '/add-provident-fund',
    name: 'add-provident-fund',
    component: AddProvidedFund,
    meta: {
      isPublic: false,
      requiresAuth: true,
      isHeader: false,
      siderBarMenu: 1,
    },
  },
  {
    path: '/edit-provident-fund/:id',
    name: 'edit-provident-fund',
    component: EditProvidedFund,
    meta: {
      isPublic: false,
      requiresAuth: true,
      isHeader: false,
      siderBarMenu: 1,
    },
  },

  //Real State Routes
  {
    path: '/real-state-dashboard',
    name: 'real-state-dashboard',
    component: RealStateDashboard,
    meta: {
      isPublic: false,
      requiresAuth: true,
      isHeader: false,
      siderBarMenu: 1,
    },
  },
  {
    path: '/add-residential-real-state',
    name: 'add-residential-real-state',
    component: AddResidentialRealState,
    meta: {
      isPublic: false,
      requiresAuth: true,
      isHeader: false,
      siderBarMenu: 1,
    },
  },
  {
    path: '/edit-residential-real-state/:id',
    name: 'edit-residential-real-state',
    component: EditResidentialRealState,
    meta: {
      isPublic: false,
      requiresAuth: true,
      isHeader: false,
      siderBarMenu: 1,
    },
  },
  {
    path: '/add-commercial-real-state',
    name: 'add-commercial-real-state',
    component: AddCommercialRealState,
    meta: {
      isPublic: false,
      requiresAuth: true,
      isHeader: false,
      siderBarMenu: 1,
    },
  },
  {
    path: '/edit-commercial-real-state/:id',
    name: 'edit-commercial-real-state',
    component: EditCommercialRealState,
    meta: {
      isPublic: false,
      requiresAuth: true,
      isHeader: false,
      siderBarMenu: 1,
    },
  },
  {
    path: '/add-industrial-real-state',
    name: 'add-industrial-real-state',
    component: AddIndustrialRealState,
    meta: {
      isPublic: false,
      requiresAuth: true,
      isHeader: false,
      siderBarMenu: 1,
    },
  },
  {
    path: '/edit-industrial-real-state/:id',
    name: 'edit-industrial-real-state',
    component: EditIndustrialRealState,
    meta: {
      isPublic: false,
      requiresAuth: true,
      isHeader: false,
      siderBarMenu: 1,
    },
  },
  {
    path: '/add-land-state',
    name: 'add-land-state',
    component: AddLandState,
    meta: {
      isPublic: false,
      requiresAuth: true,
      isHeader: false,
      siderBarMenu: 1,
    },
  },
  {
    path: '/edit-land-state/:id',
    name: 'edit-land-state',
    component: EditLandState,
    meta: {
      isPublic: false,
      requiresAuth: true,
      isHeader: false,
      siderBarMenu: 1,
    },
  },
  {
    path: '/add-real-state-investment-trust',
    name: 'add-real-state-investment-trust',
    component: AddRealStateInvestmentTrust,
    meta: {
      isPublic: false,
      requiresAuth: true,
      isHeader: false,
      siderBarMenu: 1,
    },
  },
  {
    path: '/edit-real-state-investment-trust/:id',
    name: 'edit-real-state-investment-trust',
    component: EditRealStateInvestmentTrust,
    meta: {
      isPublic: false,
      requiresAuth: true,
      isHeader: false,
      siderBarMenu: 1,
    },
  },
  {
    path: '/add-infrastructure-investment-trust',
    name: 'add-infrastructure-investment-trust',
    component: AddInfraInvestmentTrust,
    meta: {
      isPublic: false,
      requiresAuth: true,
      isHeader: false,
      siderBarMenu: 1,
    },
  },
  {
    path: '/edit-infrastructure-investment-trust/:id',
    name: 'edit-infrastructure-investment-trust',
    component: EditInfraInvestmentTrust,
    meta: {
      isPublic: false,
      requiresAuth: true,
      isHeader: false,
      siderBarMenu: 1,
    },
  },

  {
    path: '/insurance-dashboard',
    name: 'insurance-dashboard',
    component: InsuranceDashboard,
    meta: {
      isPublic: false,
      requiresAuth: true,
      isHeader: false,
      siderBarMenu: 1,
    },
  },
  {
    path: '/add-life',
    name: 'add-life',
    component: AddLife,
    meta: {
      isPublic: false,
      requiresAuth: true,
      isHeader: false,
      siderBarMenu: 1,
    },
  },
  {
    path: '/edit-life/:id',
    name: 'edit-life',
    component: EditLife,
    meta: {
      isPublic: false,
      requiresAuth: true,
      isHeader: false,
      siderBarMenu: 1,
    },
  },
  {
    path: '/add-health',
    name: 'add-health',
    component: AddHealth,
    meta: {
      isPublic: false,
      requiresAuth: true,
      isHeader: false,
      siderBarMenu: 1,
    },
  },
  {
    path: '/edit-health/:id',
    name: 'edit-health',
    component: EditHealth,
    meta: {
      isPublic: false,
      requiresAuth: true,
      isHeader: false,
      siderBarMenu: 1,
    },
  },
  {
    path: '/add-travel',
    name: 'add-travel',
    component: AddTravel,
    meta: {
      isPublic: false,
      requiresAuth: true,
      isHeader: false,
      siderBarMenu: 1,
    },
  },
  {
    path: '/edit-travel/:id',
    name: 'edit-travel',
    component: EditTravel,
    meta: {
      isPublic: false,
      requiresAuth: true,
      isHeader: false,
      siderBarMenu: 1,
    },
  },
  {
    path: '/add-group',
    name: 'add-group',
    component: AddGroup,
    meta: {
      isPublic: false,
      requiresAuth: true,
      isHeader: false,
      siderBarMenu: 1,
    },
  },
  {
    path: '/edit-group/:id',
    name: 'edit-group',
    component: EditGroup,
    meta: {
      isPublic: false,
      requiresAuth: true,
      isHeader: false,
      siderBarMenu: 1,
    },
  },
  {
    path: '/add-property',
    name: 'add-property',
    component: AddProperty,
    meta: {
      isPublic: false,
      requiresAuth: true,
      isHeader: false,
      siderBarMenu: 1,
    },
  },
  {
    path: '/edit-property/:id',
    name: 'edit-property',
    component: EditProperty,
    meta: {
      isPublic: false,
      requiresAuth: true,
      isHeader: false,
      siderBarMenu: 1,
    },
  },
  {
    path: '/add-accidental',
    name: 'add-accidental',
    component: AddAccidental,
    meta: {
      isPublic: false,
      requiresAuth: true,
      isHeader: false,
      siderBarMenu: 1,
    },
  },
  {
    path: '/edit-accidental/:id',
    name: 'edit-accidental',
    component: EditAccidental,
    meta: {
      isPublic: false,
      requiresAuth: true,
      isHeader: false,
      siderBarMenu: 1,
    },
  },
  {
    path: '/add-vehicle',
    name: 'add-vehicle',
    component: AddVehicle,
    meta: {
      isPublic: false,
      requiresAuth: true,
      isHeader: false,
      siderBarMenu: 1,
    },
  },
  {
    path: '/edit-vehicle/:id',
    name: 'edit-vehicle',
    component: EditVehicle,
    meta: {
      isPublic: false,
      requiresAuth: true,
      isHeader: false,
      siderBarMenu: 1,
    },
  },

  // Private Investment routes
  {
    path: '/private-dashboard',
    name: 'private-dashboard',
    component: PrivateInvestmentDashboard,
    meta: {
      isPublic: false,
      requiresAuth: true,
      isHeader: false,
      siderBarMenu: 1,
    },
  },
  {
    path: '/add-employee-stock-opt-scheme',
    name: 'add-employee-stock-opt-scheme',
    component: AddEmployeeStock,
    meta: {
      isPublic: false,
      requiresAuth: true,
      isHeader: false,
      siderBarMenu: 1,
    },
  },
  {
    path: '/edit-employee-stock-opt-scheme/:id',
    name: 'edit-employee-stock-opt-scheme',
    component: EditEmployeeStock,
    meta: {
      isPublic: false,
      requiresAuth: true,
      isHeader: false,
      siderBarMenu: 1,
    },
  },
  {
    path: '/add-portfolio-mgmt-services',
    name: 'add-portfolio-mgmt-services',
    component: AddPortfolioMgmt,
    meta: {
      isPublic: false,
      requiresAuth: true,
      isHeader: false,
      siderBarMenu: 1,
    },
  },
  {
    path: '/edit-portfolio-mgmt-services/:id',
    name: 'edit-portfolio-mgmt-services',
    component: EditPortfolioMgmt,
    meta: {
      isPublic: false,
      requiresAuth: true,
      isHeader: false,
      siderBarMenu: 1,
    },
  },
  {
    path: '/add-alternative-investment',
    name: 'add-alternative-investment',
    component: AddAlternateInvestment,
    meta: {
      isPublic: false,
      requiresAuth: true,
      isHeader: false,
      siderBarMenu: 1,
    },
  },
  {
    path: '/edit-alternative-investment/:id',
    name: 'edit-alternative-investment',
    component: EditAlternateInvestment,
    meta: {
      isPublic: false,
      requiresAuth: true,
      isHeader: false,
      siderBarMenu: 1,
    },
  },
  {
    path: '/get-notification-list',
    name: 'Notification',
    component: Notification,
    meta: {
      isPublic: false,
      requiresAuth: true,
      siderBarMenu: 0,
      isHeader: false,
    },
  },

  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: function () {
      return import(/* webpackChunkName: "about" */ '../views/About.vue');
    },
  },

  {
    path: '/category',
    name: 'KeepSafeCategory',
    component: KeepSafeCategory,
    meta: {
      isPublic: false,
      requiresAuth: true,
      siderBarMenu: 0,
      isHeader: false,
      siderBarMenu: 3,
    },
  },

  {
    path: '/sub-category',
    name: 'KeepSafeSubCategory',
    component: KeepSafeSubCategory,
    meta: {
      isPublic: false,
      requiresAuth: true,
      siderBarMenu: 0,
      isHeader: false,
      siderBarMenu: 3,
    },
  },

  {
    path: '/deposit-keepsafe',
    name: 'DepositKeepSafe',
    component: DepositKeepSafe,
    meta: {
      isPublic: false,
      requiresAuth: true,
      siderBarMenu: 0,
      isHeader: false,
      siderBarMenu: 3,
    },
  },

  {
    path: '/mutual-fund-keepsafe',
    name: 'MutualFundKeepSafe',
    component: MutualFundKeepSafe,
    meta: {
      isPublic: false,
      requiresAuth: true,
      siderBarMenu: 0,
      isHeader: false,
      siderBarMenu: 3,
    },
  },

  {
    path: '/real-estate-keepsafe',
    name: 'RealEstateKeepSafe',
    component: RealEstateKeepSafe,
    meta: {
      isPublic: false,
      requiresAuth: true,
      siderBarMenu: 0,
      isHeader: false,
      siderBarMenu: 3,
    },
  },

  {
    path: '/equity-bond-keepsafe',
    name: 'EquitiesBondsKeepSafe',
    component: EquitiesBondsKeepSafe,
    meta: {
      isPublic: false,
      requiresAuth: true,
      siderBarMenu: 0,
      isHeader: false,
      siderBarMenu: 3,
    },
  },

  {
    path: '/insurance-keepsafe',
    name: 'InsuranceKeepSafe',
    component: InsuranceKeepSafe,
    meta: {
      isPublic: false,
      requiresAuth: true,
      siderBarMenu: 0,
      isHeader: false,
      siderBarMenu: 3,
    },
  },

  {
    path: '/retirement-keepsafe',
    name: 'RetirementKeepSafe',
    component: RetirementKeepSafe,
    meta: {
      isPublic: false,
      requiresAuth: true,
      siderBarMenu: 0,
      isHeader: false,
      siderBarMenu: 3,
    },
  },

  {
    path: '/private-investment-keepsafe',
    name: 'PrivateInvestmentKeepSafe',
    component: PrivateInvestmentKeepSafe,
    meta: {
      isPublic: false,
      requiresAuth: true,
      siderBarMenu: 0,
      isHeader: false,
      siderBarMenu: 3,
    },
  },

  {
    path: '/commodity-keepsafe',
    name: 'CommodityKeepSafe',
    component: CommodityKeepSafe,
    meta: {
      isPublic: false,
      requiresAuth: true,
      siderBarMenu: 0,
      isHeader: false,
      siderBarMenu: 3,
    },
  },

  {
    path: '/bullions-keepsafe',
    name: 'BullionsKeepSafe',
    component: BullionsKeepSafe,
    meta: {
      isPublic: false,
      requiresAuth: true,
      siderBarMenu: 0,
      isHeader: false,
      siderBarMenu: 3,
    },
  },

  {
    path: '/tax-filling-keepsafe',
    name: 'TaxFillingKeepSafe',
    component: TaxFillingKeepSafe,
    meta: {
      isPublic: false,
      requiresAuth: true,
      siderBarMenu: 0,
      isHeader: false,
      siderBarMenu: 3,
    },
  },
  {
    path: '/my-will-keepsafe',
    name: 'MyWillKeepSafe',
    component: MyWillKeepSafe,
    meta: {
      isPublic: false,
      requiresAuth: true,
      siderBarMenu: 0,
      isHeader: false,
      siderBarMenu: 3,
    },
  },

  {
    path: '/payment-options',
    name: 'ChoosePaymentOptions',
    component: ChoosePaymentOptions,
    meta: { isPublic: true, requiresAuth: true, isHeader: true },
  },
  {
    path: '/permanently-close-account',
    name: '/PermanentlyCloseAccount',
    component: PermanentlyCloseAccount,
    meta: {
      isPublic: false,
      requiresAuth: true,
      siderBarMenu: 0,
      isHeader: false,
      siderBarMenu: 5,
    },
  },
  {
    path: '/deactivate-account',
    name: '/DeactivateAccount',
    component: DeactivateAccount,
    meta: {
      isPublic: false,
      requiresAuth: true,
      siderBarMenu: 0,
      isHeader: false,
      siderBarMenu: 5,
    },
  },
  {
    path: '/OtpVarification',
    name: '/OtpVarification',
    component: OtpVarification,
    meta: {
      isPublic: false,
      requiresAuth: true,
      siderBarMenu: 0,
      isHeader: false,
      siderBarMenu: 5,
    },
  },
  {
    path: '/FinTalk',
    name: 'FinTalk',
    component: FinTalk,
    meta: {
      isPublic: false,
      requiresAuth: true,
      siderBarMenu: 8,
      isHeader: false,
    },
  },
  {
    path: '/SudLifeFinTalk',
    name: 'SudLifeFinTalk',
    component: SudLifeFinTalk,
    meta: {
      isPublic: true,
      requiresAuth: false,
      siderBarMenu: 8,
      isHeader: false,
    },
  },
  {
    path: '/FinStat',
    name: 'FinStat',
    component: FinStat,
    meta: {
      isPublic: false,
      requiresAuth: true,
      siderBarMenu: 9,
      isHeader: false,
    },
  },
  {
    path: '/SudLifeFinStat',
    name: 'SudLifeFinStat',
    component: SudLifeFinStat,
    meta: {
      isPublic: true,
      requiresAuth: false,
      isHeader: false,
    },
  },
  {
    path: '/fintalk-category',
    name: 'FinTalkCategory',
    component: FinTalkCategory,
    meta: {
      isPublic: false,
      requiresAuth: true,
      siderBarMenu: 8,
      isHeader: false,
    },

  },

  {
    path: '/sudlife-fintalk-category',
    name: 'SudLifeFinTalkCategory',
    component: SudLifeFinTalkCategory,
    meta: {
      isPublic: true,
      requiresAuth: false,
      siderBarMenu: 8,
      isHeader: false,
    },
  },

  
  {
    path: '/finstat-category',
    name: 'FinStatCategory',
    component: FinStatCategory,
    meta: {
      isPublic: false,
      requiresAuth: true,
      siderBarMenu: 9,
      isHeader: false,
    },
  },


  {
    path: '/sudlife-finstat-category',
    name: 'SudLifeFinStatCategory',
    component: SudLifeFinStatCategory,
    meta: {
      isPublic: true,
      requiresAuth: false,
      siderBarMenu: 9,
      isHeader: false,
    },
  },


  {
    path: '/fintalk-articles',
    name: 'FinTalkArticles',
    component: FinTalkArticles,
    meta: {
      isPublic: false,
      requiresAuth: true,
      siderBarMenu: 8,
      isHeader: false,
    },
  },

  {
    path: '/sudlife-fintalk-articles',
    name: 'SudLifeFinTalkArticles',
    component: SudLifeFinTalkArticles,
    meta: {
      isPublic: true,
      requiresAuth: false,
      isHeader: false,
    },
  },


  {
    path: '/finstat-articles',
    name: 'FinStatArticles',
    component: FinStatArticles,
    meta: {
      isPublic: false,
      requiresAuth: true,
      siderBarMenu: 9,
      isHeader: false,
    },
  },
  {
    path: '/sudlife-finstat-articles',
    name: 'SudLifeFinStatArticles',
    component: SudLifeFinStatArticles,
    meta: {
      isPublic: true,
      requiresAuth: false,
      siderBarMenu: 9,
      isHeader: false,
    },
  },
  {
    path: '/read-fintalk-article',
    name: 'ReadFintalkArticle',
    component: ReadFintalkArticle,
    meta: {
      isPublic: false,
      requiresAuth: true,
      siderBarMenu: 8,
      isHeader: false,
    },
  },
  {
    path: '/read-sudlife-fintalk-article',
    name: 'SudLifeReadFintalkArticle',
    component: SudLifeReadFintalkArticle,
    meta: {
      isPublic: true,
      requiresAuth: false,
      
      isHeader: false,
    },
  },
  {
    path: '/read-finstat-article',
    name: 'ReadFinstatArticles',
    component: ReadFinstatArticles,
    meta: {
      isPublic: false,
      requiresAuth: true,
      siderBarMenu: 9,
      isHeader: false,
    },
  },
  {
    path: '/read-sudlife-finstat-article',
    name: 'SudLifeReadFinstatArticles',
    component: SudLifeReadFinstatArticles,
    meta: {
      isPublic: true,
      requiresAuth: false,
      isHeader: false,
    },
  },
  {
    path: '/read-full-articles',
    name: 'ReadFullArticles',
    component: ReadFullArticles,
    meta: {
      isPublic: false,
      requiresAuth: true,
      siderBarMenu: 8,
      isHeader: false,
    },
  },
  {
    path: '/sudlife-read-full-articles',
    name: 'SudLifeReadFullArticles',
    component: SudLifeReadFullArticles,
    meta: {
      isPublic: true,
      requiresAuth: false,
      isHeader: false,
    },
  },
  {
    path: '/read-full-finstat-articles',
    name: 'ReadFullFinstatArticle',
    component: ReadFullFinstatArticle,
    meta: {
      isPublic: false,
      requiresAuth: true,
      siderBarMenu: 9,
      isHeader: false,
    },
  },
  {
    path: '/read-sudlife-full-finstat-articles',
    name: 'SudLifeReadFullFinstatArticle',
    component: SudLifeReadFullFinstatArticle,
    meta: {
      isPublic: true,
      requiresAuth: false,
      siderBarMenu: 9,
      isHeader: false,
    },
  },
  {
    path: '/value-added-services',
    name: 'ValueAddedServices',
    component: ValueAddedServices,
    meta: {
      isPublic: false,
      requiresAuth: true,
      siderBarMenu: 7,
      isHeader: false,
    },
  },
  {
    path: '/my-will',
    name: 'MyWill',
    component: MyWill,
    meta: {
      isPublic: false,
      requiresAuth: true,
      siderBarMenu: 7,
      isHeader: false,
    },
  },
  {
    path: '/step-will/:type',
    name: 'StepsCreateWill',
    component: StepsCreateWill,
    meta: {
      isPublic: false,
      requiresAuth: true,
      siderBarMenu: 7,
      isHeader: false,
    },
  },
  {
    path: '/WillPayment/:type',
    name: 'WillPayment',
    component: WillPayment,
    meta: {
      isPublic: false,
      requiresAuth: true,
      siderBarMenu: 7,
      isHeader: false,
    },
  },
  {
    path: '/WillCreation',
    name: 'WillCreation',
    component: WillCreation,
    meta: {
      isPublic: false,
      requiresAuth: true,
      siderBarMenu: 7,
      isHeader: false,
    },
  },
  {
    path: '/memberwill/:type/:willId?',
    name: 'MemberWillCreation',
    component: MemberWillCreation,
    meta: {
      isPublic: false,
      requiresAuth: true,
      siderBarMenu: 7,
      isHeader: false,
    },
  },
  {
    path: '/creation/:type',
    name: 'Creation',
    component: Creation,
    meta: {
      isPublic: false,
      requiresAuth: true,
      siderBarMenu: 7,
      isHeader: false,
    },
  },
  {
    path: '/RegisterWill',
    name: 'RegisterWill',
    component: RegisterWill,
    meta: {
      isPublic: false,
      requiresAuth: true,
      siderBarMenu: 7,
      isHeader: false,
    },
  },
  {
    path: '/MemberDetails/:type',
    name: 'MemberDetails',
    component: MemberDetails,
    meta: {
      isPublic: false,
      requiresAuth: true,
      siderBarMenu: 7,
      isHeader: false,
    },
  },
  {
    path: '/AccountDetails/:will_id/:member_id',
    name: 'AccountDetails',
    component: AccountDetails,
    meta: {
      isPublic: false,
      requiresAuth: true,
      siderBarMenu: 7,
      isHeader: false,
    },
  },
  {
    path: '/LatestWill',
    name: 'LatestWill',
    component: LatestWill,
    meta: {
      isPublic: false,
      requiresAuth: true,
      siderBarMenu: 7,
      isHeader: false,
    },
  },


  {
    path: '/ProtectoMeterForm',
    name: 'ProtectoMeterForm',
    component: ProtectoMeterForm,
    meta: {
      isPublic: false,
      requiresAuth: true,
      siderBarMenu: 7,
      isHeader: false,
    },
  },

  {
    path: '/RetiroMeterForm',
    name: 'RetiroMeterForm',
    component: RetiroMeterForm,
    meta: {
      isPublic: false,
      requiresAuth: true,
      siderBarMenu: 7,
      isHeader: false,
    },
  },


  {
    path: '/EduMeterForm',
    name: 'EduMeterForm',
    component: EduMeterForm,
    meta: {
      isPublic: false,
      requiresAuth: true,
      siderBarMenu: 7,
      isHeader: false,
    },
  },



  {
    path: '/pay/:id',
    name: 'customer-payment',
    component: CustomerPayment,
    meta: { isPublic: true, requiresAuth: false, isHeader: false },
  },

  {
    path: '/ViewArticle',
    name: 'ViewArticle',
    component: ViewArticle,
    meta: { isPublic: true, requiresAuth: false, isHeader: false },
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

router.beforeResolve(async (to, from, next) => {
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    try {
      await Vue.prototype.$Amplify.Auth.currentAuthenticatedUser();
      next();
    } catch (e) {
      next({
        path: '/',
        query: {
          redirect: '/',
        },
      });
    }
  }

  if (to.matched.some((record) => record.meta.menu)) {
    if (!localStorage.getItem('token')) {
      next({
        path: '/admin',
      });
    }
  }

  next();
});

const timeoutInMS = 15 * 60 * 1000; // 30 minutes
let timeoutId;

function handleInactive() {
  console.log('logout');
  this.saveEmail = JwtService.getCompanyEmail();
  console.log(this.saveEmail);
  Auth.signOut()
    .then((data) => {
      localStorage.clear();
      window.location.reload();
    })
    .catch((err) => {});
}

function startTimer() {
  // setTimeout returns an ID (can be used to start or clear a timer)
  timeoutId = setTimeout(handleInactive, timeoutInMS);
}

function resetTimer() {
  clearTimeout(timeoutId);
  startTimer();
}

document.addEventListener('keypress', resetTimer, false);
document.addEventListener('mousemove', resetTimer, false);
document.addEventListener('mousedown', resetTimer, false);
document.addEventListener('touchmove', resetTimer, false);

export default router;
